import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { CommissionsCancellationSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportCommissionsCancellation, sortCommissionsCancellation } from '../../constants';
import { searchServiceCancellationExtract, searchAllServiceCancellationExtractStats } from '../../actions';
import { makeGetListCommissionsCancellation, makeGetListAllCommissionsCancellation } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class CommissionsCancellation extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      cancellationStartDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      cancellationEndtDate: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listCommissionsCancellation: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listCommissionsCancellation: props.listCommissionsCancellation,
      totalCount: getPageTotalCount({ ...state, items: props.listCommissionsCancellation }),
    };
  }

  componentDidMount() {
    this.doGetListCommissionsCancellation();
    const {
      permissions: { modeGetCancellationExtract },
    } = this.props;
    if (modeGetCancellationExtract) {
      this.doGetListCommissionsCancellation();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListCommissionsCancellation();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListCommissionsCancellation());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListCommissionsCancellation());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListCommissionsCancellation();
    });
  };

  doGetListCommissionsCancellation = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchServiceCancellationExtract } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortCommissionsCancellation[sorted.sortCol]
          ? sortCommissionsCancellation[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    searchServiceCancellationExtract(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistCommissionsCancellation = cb => {
    const { filter, sorted } = this.state;
    const { searchAllServiceCancellationExtractStats } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortCommissionsCancellation[sorted.sortCol][sorted.sortDir] : null,
    };
    searchAllServiceCancellationExtractStats(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistCommissionsCancellation(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllCommissionsCancellation, t } = this.props;
        convertJson2Pdf({
          data: listAllCommissionsCancellation,
          t,
          title: t('reportPage:sidebar.commissionsCancellations').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.commissionsCancellations')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistCommissionsCancellation(() => {
      const { listAllCommissionsCancellation, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'SEARCH_SERVICE_CANCELLATION_EXTRACT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.commissionsCancellations')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.commissionsCancellations')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllCommissionsCancellation,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { jobType: 'jobTypes', jobStatus: 'jobStatus' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllCommissionsCancellation,
          t,
          title: t('reportPage:sidebar.commissionsCancellations').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.commissionsCancellations')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.commissionsCancellations')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('COMMISSIONS_COLLECTIONS_EXTRACTS', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportCommissionsCancellation,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listCommissionsCancellation,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllCommissionsCancellation,
      t,
      permissions: { modeGetCancellationExtract, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetCancellationExtract) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.commissionsCancellations') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.commissionsCancellations')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <CommissionsCancellationSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.commissionsCancellations').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllCommissionsCancellation,
                          t,
                          title: t('reportPage:sidebar.commissionsCancellations').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.commissionsCancellations')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listCommissionsCancellation}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listCommissionsCancellation && listCommissionsCancellation.length ? listCommissionsCancellation : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

CommissionsCancellation.propTypes = {
  searchServiceCancellationExtract: PropTypes.func,
  searchAllServiceCancellationExtractStats: PropTypes.func,
  listAllCommissionsCancellation: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

CommissionsCancellation.defaultProps = {
  searchServiceCancellationExtract: () => {},
  searchAllServiceCancellationExtractStats: () => {},
  listAllCommissionsCancellation: [],
};

const mapStateToProps = createStructuredSelector({
  listCommissionsCancellation: makeGetListCommissionsCancellation() || [],
  listAllCommissionsCancellation: makeGetListAllCommissionsCancellation() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    searchServiceCancellationExtract,
    searchAllServiceCancellationExtractStats,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(CommissionsCancellation)
);
